import React from 'react';
import { withRouter, NavLink } from 'react-router-dom';
import { connect } from 'react-redux';

import Spin from '../../../components/loading';
import ShowForPermission from '../../../components/ShowForPermission';
import DeleteReservationHour from './DeleteModal';

import ENUMS from '../../../enums/index';
import * as reserveTimesActions from '../../../redux/reserveTimes/actions';
import { enumHelper } from '../../../utils';
import Select from 'react-select';
import AlertAndConfirmation from '../../../utils/AlertAndConfirmation';

class ReserveHoursListTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      reservationHourOpen: false,
      selectedReservationHourId: null,
      deleteReservationHourOpen: false,
    };
  }

  displayDeleteReservationHourOpen = id => {
    let { reservationHoursList = [] } = this.props;
    let selectedReservationHourId = reservationHoursList.filter(
      reservationHour => reservationHour.id == id,
    )[0].id;
    this.setState({
      deleteReservationHourOpen: true,
      selectedReservationHourId,
    });
  };

  closeDeleteReservationHour = () => {
    const query = this.buildSearchQuery(
      this.props.pageNumber,
      this.props.pageSize,
    );
    this.props.actions
      .fetchAllReservationHours(query, this.props.reservationDayId)
      .then(() => {
        this.setState(() => ({
          deleteReservationHourOpen: false,
        }));
      });
  };

  buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&${this.state.query || 'sort=createdAt-desc'}`;
      return query;
    }
  };

  renderStatusColors = status => {
    switch (status) {
      case 'READY': {
        return 'text-success';
      }
      case 'DISABLE': {
        return 'text-danger';
      }
      default:
        return 'text-muted';
    }
  };

  handleStatusChange = (item, status) => {
    let updateObject = {
      id: item.id,
      cafeTableId: item.cafeTableId,
      fromTime: item.fromTime,
      toTime: item.toTime,
      status: status
    };

    this.props.actions.updateReservationHour(updateObject).then(() => {
      let { updateFailed, updateMessage, updateError } = this.props;
      if (updateFailed == false && updateMessage == null && updateError == false) {
        AlertAndConfirmation({
          title: locales('titles.editionsDoneSuccessfully'),
          text: '',
          type: 'success'
        });
      }

      const newQuery = `pageNumber=${this.props.pageNumber}&pageSize=${this.props.pageSize}`;
      // this.props.actions.fetchAllReservationHours(
      //   newQuery,
      //   this.props.reservationDayId
      // );
    });

  };

  render() {
    let {
      reservationHoursList = [],
      pageNumber,
      pageSize,
      loading,
      error,
      message,
      failed,
    } = this.props;

    return (
      <>
        <Spin spinning={loading}>
          <table className='table table-hover table-light table-striped'>
            <thead>
              <tr>
                <th className='text-center'>{locales('tables.row')}</th>
                <th className='text-center'>{locales('tables.date')}</th>
                <th className='text-center'>{locales('tables.fromHour')}</th>
                <th className='text-center'>{locales('tables.toHour')}</th>
                <th className='text-center'>{locales('tables.status')}</th>
                <th className='text-center'>{locales('tables.tableNumber')}</th>
                <th className='text-center'>{locales('tables.creator')}</th>
                {/* <th className="text-center">
                </th> */}
                <th className='text-center'></th>
              </tr>
            </thead>
            <tbody>
              {reservationHoursList.length ? (
                reservationHoursList.map((reservationHour, index) => (
                  <tr key={reservationHour.id}>
                    <td className='text-center'>
                      {(pageNumber - 1) * pageSize + index + 1}
                    </td>
                    <td className='text-center'>{reservationHour.date}</td>
                    <td className='text-center'>{reservationHour.fromTime}</td>
                    <td className='text-center'>{reservationHour.toTime}</td>
                    <td
                      className={`text-center ${this.renderStatusColors(
                        reservationHour.status,
                      )}`}
                    >
                      {enumHelper.convertEnumValueToTitle(
                        ENUMS.CAFE_RESERVATION_HOURS.list,
                        reservationHour.status,
                      )}
                    </td>
                    <td className='text-center'>
                      {reservationHour.tableNumber}
                    </td>
                    <td className='text-center'>
                      {reservationHour.createdFullName}
                    </td>
                    <td title={locales('titles.editReservationHour')}>
                      <ShowForPermission
                        permission={
                          ENUMS.PERMISSIONS.values.EDIT_CAFE_TIME_SLICE
                        }
                      >
                        {/*    <NavLink
                          to={{
                            pathname: '/reservation/hours/edit',
                            editMode: true,
                            reservationDayDate: this.props.reservationDayDate,
                            reservationDayId: this.props.reservationDayId,
                            reservationHourId: reservationHour.id,
                          }}
                        >
                          <i className='text-center fa fa-pencil text-secondary pointer' />
                        </NavLink> */}

                        <Select
                          name="status"
                          className="p-0 col-12"
                          isMulti={false}
                          placeholder={enumHelper.convertEnumValueToTitle(
                            ENUMS.CAFE_RESERVATION_HOURS.list.slice(0, 2),
                            reservationHour.status
                          )}
                          options={ENUMS.CAFE_RESERVATION_HOURS.list.slice(0, 2).map(status => ({
                            label: status.title,
                            value: status.value
                          }))}
                          onChange={selectedStatus =>
                            this.handleStatusChange(reservationHour, selectedStatus.value)
                          }
                        />
                      </ShowForPermission>
                    </td>
                    <td title={locales('titles.deleteReservationHour')}>
                      <ShowForPermission
                        permission={
                          ENUMS.PERMISSIONS.values.DELETE_CAFE_TIME_SLICE
                        }
                      >
                        <i
                          onClick={() =>
                            this.displayDeleteReservationHourOpen(
                              reservationHour.id,
                            )
                          }
                          className='text-center fal fa-trash text-danger pointer'
                        />
                      </ShowForPermission>
                    </td>
                  </tr>
                ))
              ) : (
                <tr className='col-12 text-center'>
                  <td className='alert alert-info' colSpan={13}>
                    {locales('alerts.noRecord')}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          {this.state.deleteReservationHourOpen && (
            <DeleteReservationHour
              title={this.state.selectedTitle}
              isOpen={this.state.deleteReservationHourOpen}
              reservationHourId={this.state.selectedReservationHourId}
              closeModal={this.closeDeleteReservationHour}
            />
          )}
        </Spin>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    reservationHoursList: state.reserveTimesReducer.reservationHoursList,
    reservationHours: state.reserveTimesReducer.reservationHours,
    loading: state.reserveTimesReducer.loading,
    message: state.reserveTimesReducer.message,
    failed: state.reserveTimesReducer.failed,
    error: state.reserveTimesReducer.error,
    updateLoading: state.reserveTimesReducer.updateReservationHourLoading,
    updateMessage: state.reserveTimesReducer.updateReservationHourMessage,
    updateFailed: state.reserveTimesReducer.updateReservationHourFailed,
    updateError: state.reserveTimesReducer.updateReservationHourError,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      fetchAllReservationHours: (query, cafeDateId) =>
        dispatch(
          reserveTimesActions.fetchAllReservationHours(query, cafeDateId),
        ),
      updateReservationHour: reservationHourObject =>
        dispatch(reserveTimesActions.updateReservationHour(reservationHourObject)),
    },
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ReserveHoursListTable),
);
